/* Copyright (c) 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { LoaderWrap } from "~/components/Loader";
import { ROUTES } from "~/routing/routes";
import { DataBox } from "../DataBox/DataBox";
import { StatusChart } from "../StatusChart/StatusChart";
import { StatusChartItem } from "../types";

type Props = {
  items: StatusChartItem[];
  count: number;
  loading: boolean;
};

export function ResourcesCard({ items, count, loading }: Props) {
  return (
    <DataBox
      icon="machineSettings"
      title="Resources"
      value={count}
      iconLink={ROUTES.resources.index}
      flex={2}
    >
      <LoaderWrap loading={loading} inContent>
        <StatusChart
          items={items}
          isDonutChart={false}
          chartLabel="Resources"
        />
      </LoaderWrap>
    </DataBox>
  );
}
